import type {
  LinkPlugin,
  PlatePlugin,
  TComboboxItemBase,
} from '@udecode/plate';
import {
  createPlateUI,
  ELEMENT_LINK,
  ELEMENT_MENTION,
  ELEMENT_PARAGRAPH,
  PlateFloatingLink,
  StyledElement,
  withProps,
} from '@udecode/plate';

import {
  CustomMentionElement,
  LinkComponent,
} from '@/components/Comment/Editor/components';

export const components = createPlateUI({
  [ELEMENT_PARAGRAPH]: withProps(StyledElement, {
    as: 'p',
    styles: {
      root: {
        margin: 0,
      },
    },
    prefixClassNames: 'p',
  }),
  [ELEMENT_LINK]: LinkComponent,
  [ELEMENT_MENTION]: CustomMentionElement,
});

export const linkPlugin: Partial<PlatePlugin<LinkPlugin>> = {
  renderAfterEditable: PlateFloatingLink,
};

export const mentionPlugin = {
  key: '@',
  component: CustomMentionElement,
  options: {
    trigger: '@',
    createMentionNode: (item: TComboboxItemBase) => ({
      [MENTION_NODE_KEY]: item.key,
      [MENTION_NODE_VALUE]: item.text,
    }),
    insertSpaceAfterMention: true,
  },
};

export const MENTION_NODE_KEY = 'mention_uuid';
export const MENTION_NODE_VALUE = 'mention_value';
